
interface ThisProps {
//  uidAuftrag: string;
}

/**
 * @author noone
 */
const AnleitungDownloadButtonComponent: React.FC<ThisProps> = ({  }) => {

   const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/KURZANLEITUNG.pdf"; // Pfad zur PDF im public-Ordner
    link.download = "KURZANLEITUNG.pdf";     // gewünschter Dateiname
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>

      <button className="btn btn-secondary" onClick={handleDownload}>
            <i className="bi bi-download"></i> Kurzanleitung als PDF
          </button>
    </>
  );

}

export default AnleitungDownloadButtonComponent;